let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eDho8")).then(() => parcelRequire('ipDda'));